var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFire(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.0044 13.519L9.97439 15.519C9.51439 15.979 9.15439 16.549 9.04439 17.189C8.74439 19.029 10.1844 20.619 12.0044 20.619C13.8244 20.619 15.2644 19.029 14.9644 17.199C14.8544 16.559 14.5044 15.979 14.0344 15.529L12.0044 13.519Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.5644 7.16901C14.3844 8.63901 12.0044 7.80901 12.0044 5.91901V4.38901C12.0044 3.58901 11.1144 3.10901 10.4544 3.54901C8.12439 5.10901 4.00439 8.58901 4.00439 13.619C4.00439 16.539 5.56439 19.089 7.89439 20.479C7.18439 19.459 6.83439 18.169 7.08439 16.799C7.27439 15.759 7.83439 14.819 8.59439 14.079L11.3044 11.409C11.6944 11.029 12.3144 11.029 12.7044 11.409L15.4344 14.099C16.1744 14.829 16.7344 15.749 16.9144 16.779C17.1644 18.139 16.8444 19.419 16.1444 20.439C18.0344 19.289 19.4344 17.379 19.8544 15.139C20.4644 11.869 19.0444 8.76901 16.6344 7.03901C16.3044 6.78901 15.8344 6.83901 15.5644 7.16901Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFire);
export default __webpack_public_path__ + "static/media/Fire.7ac4dbb369462cbc1e4e03ced4afa615.svg";
export { ForwardRef as ReactComponent };